import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import { HOME } from '../../../constants/routes';
import { TIME_MORNING } from '../../../constants/return-goods';
import { DEFAULT_DATE_FORMAT } from '../../../utils/time';
import { useAppWidthClass } from '../../../utils/hooks';

import { CustomIcon, Text, ThemeButton } from '../../../components/common';
import illustration from '../../../assets/img/installment_feedback/installment_thanks.png';

import { ReturnGoodsContactDetails } from '../index';

const useStyles = makeStyles(theme => ({
  titleRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  illustration: {
    height: 40
  },
  title: {
    marginLeft: theme.spacing(2)
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto'
  },
  description: {
    marginTop: theme.spacing(4),
    textAlign: 'center'
  },
  section: {
    marginTop: theme.spacing(2)
  },
  pickup: {
    display: 'flex',
    alignItems: 'center'
  },
  date: {
    marginLeft: theme.spacing(1)
  },
  time: {
    marginLeft: theme.spacing(2)
  },
  line: {
    display: 'inline-block',
    margin: `${theme.spacing(1)}px 0`,
    width: '100%',
    height: 1,
    background: theme.palette.text.disabled
  },
  confirmationText: {
    paddingTop: theme.spacing(2),
    textAlign: 'center'
  },
  textLeft: {
    textAlign: 'left'
  },
  buttons: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',

    '& > button': {
      width: 240
    }
  }
}));

const ReturnGoodsSummaryView = ({
  contentClass,
  pickupDate,
  time,
  customerName,
  street,
  postCode,
  city,
  addressCountry,
  phone
}) => {
  const classes = useStyles();
  const history = useHistory();
  const { isDesktopWidth } = useAppWidthClass();

  const onHomeClick = () => history.push(HOME);

  return (
    <>
      <Box className={classes.titleRow}>
        <img
          className={classes.illustration}
          src={illustration}
          alt="illustration"
        />
        <Text
          className={classes.title}
          component="h1"
          variant="h4"
          color="secondary"
        >
          Thank You
        </Text>
      </Box>
      <Box className={classNames(classes.content, contentClass)}>
        <Text
          className={classNames(
            classes.description,
            !isDesktopWidth && classes.textLeft
          )}
          component="p"
          variant="body1"
          color="textPrimary"
        >
          Thanks Ulf, we have received your preferred pickup date and will soon
          send your a confirmation via E-Mail.
        </Text>
        <Box className={classes.section}>
          <Text component="h2" variant="h3" color="textPrimary">
            Summary
          </Text>
        </Box>
        <Box className={classes.section}>
          <Text component="h3" variant="h4" color="textPrimary">
            Pickup date
          </Text>
        </Box>
        <Box className={classNames(classes.section, classes.pickup)}>
          <CustomIcon icon="calendar" size="small" variant="primary" />
          <Text
            className={classes.date}
            component="span"
            variant="body1Bold"
            color="textPrimary"
          >
            {moment(pickupDate).format(DEFAULT_DATE_FORMAT)}
          </Text>
          <Text
            className={classes.time}
            component="span"
            variant="body1"
            color="textPrimary"
          >
            {time === TIME_MORNING ? 'In the morning' : 'In the afternoon'}
          </Text>
        </Box>
        <Box className={classes.section}>
          <Box className={classes.line} />
        </Box>
        <ReturnGoodsContactDetails
          title="Pickup address"
          customerName={customerName}
          street={street}
          postCode={postCode}
          city={city}
          addressCountry={addressCountry}
          phone={phone}
        />
        <Box className={classes.section}>
          <Text
            className={classNames(
              classes.confirmationText,
              !isDesktopWidth && classes.textLeft
            )}
            component="p"
            variant="body1"
            color="textPrimary"
          >
            If you have any further questions in the meanwhile, please do not
            hesitate to reach out to us.
          </Text>
        </Box>
        <Box className={classes.buttons}>
          <ThemeButton
            id="page.return-goods.summary.home-button"
            variant="contained"
            size="large"
            endIcon="chevronRight"
            endIconColor="primaryContrast"
            textKey={'Home'}
            onClick={onHomeClick}
          />
        </Box>
      </Box>
    </>
  );
};

export default ReturnGoodsSummaryView;
